var styles = {"container":"styles_container__Cuo5X mx-auto col-12 md-col-4 mt1","placement-modal":"styles_placement-modal__1tPiI","placementModal":"styles_placement-modal__1tPiI","label":"styles_label__1KzKq"};

export default styles;
//# sourceMappingURL=styles.css.js.map
